import React, { useEffect, useState } from 'react';
import Page from '../../components/Page/Page';
import styled from '@emotion/styled';
import Nav from '../../layout/UsersDashboard/sideNav/Nav';
import MobileNav from '../../layout/UsersDashboard/sideNav/MobileNav';
import DashboardHeader from '../../layout/UsersDashboard/header/DashboardHeader';
import PageBanner from '../../components/Banner/PageBanner';
import { ACCOUNT, SIGNUP } from '../../routes/routeConstants';
import { InternalNavLink } from '../../components/Link/Link';
import LocumCard from '../../components/Card/LocumCard';
import { dummyLocums } from './DummyGuest';
import DummyLocumProfile from './DummyLocumProfile';

const ViewOnlyLocums = () => {
  const [open, setOpen] = useState(false);
  // parent‐owned mobile flag:
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Locumspace | Guest">
      <Container>
        <Nav guest />
        <MobileNav
          guest
          open={open}
          toggleNav={() => {
            setOpen(!open);
          }}
        />
        <Section>
          <DashboardHeader
            guest
            open={open}
            toggleNav={() => {
              setOpen(!open);
            }}
          />
          {/* {splitLocation[3] === 'settings' && <SettingsHeader />} */}
          <MainContent>
            <Shell>
              <PageBanner
                label="Guest Access"
                description="Please sign in as a recruiter to discover more Locums"
                className={``}
              />
              {!isMobile ? (
                <Container2>
                  <CardDiv>
                    {dummyLocums.map((locum) => (
                      <LocumCard
                        {...locum}
                        key={locum.id}
                        isMobile={isMobile}
                        guest
                      />
                    ))}
                  </CardDiv>
                  <DisplayDiv>
                    <DummyLocumProfile
                      locum={dummyLocums[0]}
                      resume={dummyLocums[0]?.profileImage ?? null}
                    />
                  </DisplayDiv>
                </Container2>
              ) : (
                <Contain>
                  {dummyLocums.map((locum) => (
                    <LocumCard
                      {...locum}
                      key={locum.id}
                      isMobile={isMobile}
                      guest
                    />
                  ))}
                </Contain>
              )}
            </Shell>
          </MainContent>
          <Div>
            {' '}
            <See to={`/${ACCOUNT}/${SIGNUP}`}>See more</See>
          </Div>
        </Section>
      </Container>
    </Page>
  );
};

export default ViewOnlyLocums;

const Container = styled.div`
  display: grid;
  grid-template-columns: 294px 1fr;
  height: 100vh;
  overflow: auto;
  width: 100%;
  background-color: #f2f8fd;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
  }
`;

const Contain = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 2rem;
  border-radius: 0.75rem;
  height: 28rem;
  overflow: auto;

  /* Hide scrollbar but keep scrolling */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  @media (max-width: 860px) {
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 0;
    border-radius: 0;
    background-color: ${({ theme }) => theme.palette.backgroundColor};
    height: 57rem;
    overflow: auto;
    flex-wrap: nowrap;
    gap: 20px;
    padding-bottom: 2rem;
  }

  @media (max-width: 480px) {
    height: 40rem;
    padding-bottom: 0;
  }

  @media (min-width: 1440px) {
    justify-content: space-around;
    align-items: start;
    gap: 20px;
    height: 35rem;
  }
`;

const Section = styled.section`
  width: 100%;
  height: fit-content;

  & > * {
    padding-left: 54px;
    padding-right: 54px;
  }

  @media (max-width: 884px) {
    & > * {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
`;

const MainContent = styled.main`
  height: 100%;
  width: 100%;
`;

const Shell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Container2 = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  gap: 10px;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 0.75rem;
  border-radius: 0.75rem;
  height: 33rem;
  overflow: auto;
  overflow-x: hidden;

  @media (max-width: 860px) {
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 0;
    border-radius: 0;
    background-color: ${({ theme }) => theme.palette.backgroundColor};
    height: 57rem;
    overflow: auto;
    flex-wrap: nowrap;
    gap: 20px;
    padding-bottom: 2rem;
  }

  @media (max-width: 480px) {
    height: 40rem;
    padding-bottom: 0;
  }

  @media (min-width: 1440px) {
    justify-content: space-around;
    align-items: start;
    gap: 20px;
    height: 43rem;
  }
`;

const CardDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 1rem;
`;

const DisplayDiv = styled.div`
  border: 1.4px solid ${({ theme }) => theme.palette.greyGrey3};
  border-radius: 0.25rem;
  padding: 0.75rem;
  flex-grow: 1;
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 2rem;
`;

const See = styled(InternalNavLink)`
  color: ${({ theme }) => theme.palette.mainBlue};
  text-decoration: underline;
`;
